import { React, useState } from "react";
import {
  LibraryIcon,
  ChevronRightIcon,
  CubeIcon,
  TagIcon,
  IdentificationIcon,
} from "@heroicons/react/solid";
import DeptModal from "../../../components/admin/admin-access/DeptModal";
import DomainModal from "../../../components/admin/admin-access/DomainModal";
import TagModal from "../../../components/admin/admin-access/TagModal";
import AdminModal from "../../../components/admin/admin-access/AdminModal";

const AdminAccess = () => {
  const [isDeptModalOpened, setDeptModalOpened] = useState(false);
  const [isDomainModalOpened, setDomainModalOpened] = useState(false);
  const [isTagModalOpened, setTagModalOpened] = useState(false);
  const [isAdminModalOpened, setAdminModalOpened] = useState(false);

  return (
    <>
      <div className="md:px-40 px-10 py-20 w-full">
        <h1 className="text-3xl text-[#1E1E4A] font-semibold mb-16">
          Admin Controls
        </h1>
        <div className="flex flex-col text-xl text-gray-700">
          <div
            onClick={() => setDeptModalOpened(true)}
            className="flex flex-row justify-between place-items-center rounded-md p-4 bg-gray-200 mb-4 hover:cursor-pointer shadow-md"
          >
            <div className="flex flex-row place-items-center">
              <LibraryIcon className="w-10 mr-5 fill-gray-500" />
              <h1>Departments</h1>
            </div>
            <ChevronRightIcon className="w-10 fill-gray-400" />
          </div>
          <div
            onClick={() => setDomainModalOpened(true)}
            className="flex flex-row justify-between place-items-center rounded-md p-4 bg-gray-200 mb-4 hover:cursor-pointer shadow-md"
          >
            <div className="flex flex-row place-items-center">
              <CubeIcon className="w-10 mr-5 fill-gray-500" />
              <h1>Domains</h1>
            </div>
            <ChevronRightIcon className="w-10 fill-gray-400" />
          </div>
          <div
            onClick={() => setTagModalOpened(true)}
            className="flex flex-row justify-between place-items-center rounded-md p-4 bg-gray-200 mb-4 hover:cursor-pointer shadow-md"
          >
            <div className="flex flex-row place-items-center">
              <TagIcon className="w-10 mr-5 fill-gray-500" />
              <h1>Tags</h1>
            </div>
            <ChevronRightIcon className="w-10 fill-gray-400" />
          </div>
          <div
            onClick={() => setAdminModalOpened(true)}
            className="flex flex-row justify-between place-items-center rounded-md p-4 bg-gray-200 mb-4 hover:cursor-pointer shadow-md"
          >
            <div className="flex flex-row place-items-center">
              <IdentificationIcon className="w-10 mr-5 fill-gray-500" />
              <h1>Admins</h1>
            </div>
            <ChevronRightIcon className="w-10 fill-gray-400" />
          </div>
        </div>
        <DeptModal
          title={"Edit Departments"}
          url={"j"}
          show={isDeptModalOpened}
          onCloseCallback={() => setDeptModalOpened(false)}
        />
        <DomainModal
          title={"Edit Domains"}
          url={"j"}
          show={isDomainModalOpened}
          onCloseCallback={() => setDomainModalOpened(false)}
        />
        <TagModal
          title={"Edit Tags"}
          url={"j"}
          show={isTagModalOpened}
          onCloseCallback={() => setTagModalOpened(false)}
        />
        <AdminModal
          title={"Update Admins"}
          url={"j"}
          show={isAdminModalOpened}
          onCloseCallback={() => setAdminModalOpened(false)}
        />
      </div>
    </>
  );
};

export default AdminAccess;
